(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-newsletter-popup]');
    if (!root) return;

    var key = root.getAttribute('data-session-key') || 'sigma_newsletter_popup_session';
    if (window.sessionStorage && sessionStorage.getItem(key)) return;

    var delay = parseInt(root.getAttribute('data-delay-ms') || '3000', 10);
    if (isNaN(delay) || delay < 0) delay = 3000;

    var shell = root.querySelector('.newsletter-popup__shell');
    var closeBtn = root.querySelector('[data-newsletter-popup-close]');
    var backdrop = root.querySelector('[data-newsletter-popup-backdrop]');
    var form = root.querySelector('form');

    function markDismissed() {
      try {
        sessionStorage.setItem(key, '1');
      } catch (e) {}
    }

    function lockScroll() {
      document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.documentElement.style.removeProperty('overflow');
    }

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('hidden', '');
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      unlockScroll();
      markDismissed();
    }

    function open() {
      if (window.sessionStorage && sessionStorage.getItem(key)) return;
      root.classList.add('is-open');
      root.removeAttribute('hidden');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
      document.addEventListener('keydown', onKeydown);
      if (closeBtn) closeBtn.focus();
      else if (shell) shell.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    if (form) {
      form.addEventListener('submit', function () {
        markDismissed();
      });
    }

    window.setTimeout(function () {
      if (window.sessionStorage && sessionStorage.getItem(key)) return;
      open();
    }, delay);
  })();
  } catch(e) { console.error(e); }
})();

})();
